/* T8 accordion: one item open at a time per [data-t8-acc]; Show More reveals [hidden] items */
(function () {
  'use strict';
  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var btn = item.querySelector('.t8-acc__btn'); if (btn) btn.setAttribute('aria-expanded', String(open));
  }
  function init(root) {
    (root || document).querySelectorAll('[data-t8-acc]').forEach(function (list) {
      if (list.dataset.ready) return; list.dataset.ready = '1';
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.t8-acc__btn'); if (!btn || !list.contains(btn)) return;
        var item = btn.closest('[data-t8-acc-item]'); var open = !item.classList.contains('is-open');
        list.querySelectorAll('[data-t8-acc-item].is-open').forEach(function (o) { if (o !== item) setOpen(o, false); });
        setOpen(item, open);
      });
      var more = list.parentElement && list.parentElement.querySelector('[data-t8-acc-more]');
      if (more && !more.dataset.ready) {
        more.dataset.ready = '1'; more.dataset.more = more.textContent.trim();
        more.addEventListener('click', function () {
          var hidden = list.querySelectorAll('[data-t8-acc-item][hidden]');
          var expanding = hidden.length > 0;
          if (expanding) hidden.forEach(function (i) { i.hidden = false; i.dataset.t8Extra = '1'; });
          else list.querySelectorAll('[data-t8-acc-item][data-t8-extra]').forEach(function (i) { i.hidden = true; setOpen(i, false); });
          more.textContent = expanding ? (more.dataset.less || more.dataset.more) : more.dataset.more;
          more.setAttribute('aria-expanded', String(expanding));
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
